module.exports = __webpack_public_path__ + "files/c9167c105656a203df302421666e0631.png";